import { DeviceTypeEnum } from '../../types/campaignsJson';
var MOBILE_SCREEN_MAX_WIDTH = 768;
function isScreenMobile() {
    return window.innerWidth <= MOBILE_SCREEN_MAX_WIDTH;
}
export function getLocation() {
    return window.location.href;
}
export function getDevice() {
    var isMobile = isScreenMobile();
    return isMobile ? DeviceTypeEnum.MOBILE : DeviceTypeEnum.DESKTOP;
}
